export default function ComparisonIntro({ heading, paragraphs, cards }) {
  return (
    <section className="py-[100px] px-6 lg:px-10 bg-base-white">
      <div className="max-w-[1100px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left text */}
          <div className="fade-in">
            <h3 className="font-inter text-[28px] font-extrabold tracking-[-1px] leading-[1.2] mb-5">
              {heading}
            </h3>
            {paragraphs.map((p, i) => (
              <p
                key={i}
                className="font-inter text-[15px] text-gray-cool-500 leading-[1.8] mb-4"
                dangerouslySetInnerHTML={{ __html: p }}
              />
            ))}
          </div>

          {/* Right visual */}
          <div className="bg-cream rounded-[20px] p-8 lg:p-10 fade-in">
            {cards.map((card, i) => (
              <div
                key={i}
                className="bg-base-white rounded-2xl p-6 shadow-[0_2px_16px_rgba(0,0,0,0.06)] mb-4 last:mb-0"
              >
                <div
                  className={`text-[11px] font-bold uppercase tracking-[1px] mb-2 flex items-center gap-1.5 ${card.labelColor || "text-blue-primary-500"}`}
                >
                  {card.icon}
                  {card.label}
                </div>
                <h4 className="font-inter text-[15px] font-bold mb-1">
                  {card.title}
                </h4>
                <p className="font-inter text-[13px] text-gray-cool-500 leading-[1.5]">
                  {card.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
